<!--
 * @Description: 业务追踪页面
 * @Author: laoliu,wanqian
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <biz-data />
</template>

<script>
export default {
  mounted() {
      this.$emit("breadcrumb", {text1: '系统管理', text2: '业务追踪'});
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sysmng/BizTrack.vue